<template>
  <b-navbar toggleable="lg" type="dark" id="menu"
    :style="'background-color: ' + siteConfiguration.navbar_background_color">
    <div class="container">

      <b-navbar-toggle target="nav-collapse" style="margin: 5px 0px;">
        <span class="navbar-toggler-icon"></span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="justify-content-center">
        <b-navbar-nav>
          <template v-for="(link, index) in siteConfiguration.navbar_links">
            <b-nav-item class="nav-link" :href="link.url" target="_self"  :key="index"
              :link-attrs="{style: 'color: ' + siteConfiguration.navbar_links_color || '#0000EE'}">
              {{ link.name }}
            </b-nav-item>

            <span v-if="(siteConfiguration.navbar_links.length - 1) !== index"
              class="separator d-none d-md-block" :key="index + 'separator'">
              -
            </span>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: 'LayoutCustomNavbar',
  props: {
    siteConfiguration: {
      type: Object,
      required: true
    },
    disableEventsButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return { }
  }
}
</script>
